import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "v1-group__title",
  "data-testid": "v1-group-title"
}
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageLoading = _resolveComponent("PageLoading")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_ProviderLogoGrid = _resolveComponent("ProviderLogoGrid")!
  const _component_V1ScreenScaffold = _resolveComponent("V1ScreenScaffold")!
  const _component_NoPayments = _resolveComponent("NoPayments")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_PageLoading, { key: 0 }))
      : (_ctx.error)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, { key: 1 }))
        : (_ctx.groupSection && _ctx.groupSection.group)
          ? (_openBlock(), _createBlock(_component_V1ScreenScaffold, {
              key: 2,
              "next-disabled": !_ctx.canContinue,
              "data-testid": "v1-provider-group",
              onNext: _ctx.handleContinue
            }, {
              default: _withCtx(() => [
                _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.groupSection.group.title || _ctx.groupSection.title), 1),
                _createVNode(_component_ProviderLogoGrid, {
                  buckets: _ctx.gridBuckets,
                  "selected-key": _ctx.selectedKey,
                  onSelect: _ctx.onGridSelect
                }, null, 8, ["buckets", "selected-key", "onSelect"])
              ]),
              _: 1
            }, 8, ["next-disabled", "onNext"]))
          : (_openBlock(), _createBlock(_component_NoPayments, { key: 3 })),
    _createVNode(_component_Modal, {
      "model-value": _ctx.activePopup !== null,
      title: _ctx.popupTitle,
      "primary-text": _ctx.popupPrimaryText,
      "secondary-text": _ctx.popupSecondaryText || undefined,
      placement: "bottom",
      "data-testid": "v1-group-popup",
      onPrimary: _ctx.onPopupPrimary,
      onSecondary: _ctx.onPopupSecondary,
      "onUpdate:modelValue": _ctx.onPopupModel
    }, {
      default: _withCtx(() => [
        (_ctx.activePopup && _ctx.activePopup.notice)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.activePopup.notice.body), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model-value", "title", "primary-text", "secondary-text", "onPrimary", "onSecondary", "onUpdate:modelValue"])
  ], 64))
}